import { subscriptionStatus } from '@app/constants/subscribe';

export function mapUserOptions(userOptions = [], optionsHistory = []) {
  return userOptions.map((subscription) => {
    const {
      name, type, synopsis, priceWithoutVat,
    } = optionsHistory.find(({ idOption }) => idOption === subscription.optionId) || {};
    return {
      ...subscription, priceWithoutVat, synopsis, name, type,
    };
  });
}

export function getSubscriptionActiveStatus(userOptions = []) {
  return !!userOptions
    .find(({ statusId }) => [
      subscriptionStatus.TERMINATED,
      subscriptionStatus.ACTIVE,
    ].includes(statusId));
}
